import { render, staticRenderFns } from "./LevCheckbox.vue?vue&type=template&id=1f6a9bcf"
import script from "./LevCheckbox.vue?vue&type=script&lang=js"
export * from "./LevCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports